import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import {
  addBrandIncomeExpense,
  getBrandIncomeExpenseCategory,
  updateBrandIncomeExpense,
} from "../../../services/IncomeExpense/IncomeExpense";
import { InputTextarea } from "primereact/inputtextarea";
import SuccessModal from "../../SuccessModal";

const IncomeExpenseCreateModal = ({
  incomeExpenseCreateModalVisible,
  setIncomeExpenseCreateModalVisible,
  sendDataToUserList,
  brandId,
  selectedUserItemValue,
}) => {
  const [nameValue, setNameValue] = useState("");
  const [descriptionValue, setDescriptionValue] = useState("");
  const [categoryValue, setCategoryValue] = useState("");

  const [nameError, setNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [categoryError, setCategoryError] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const [statusValue, setStatusValue] = useState("");
  const [statusError, setStatusError] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [categoryItems, setCategoryItems] = useState([]);

  const fetchBrandIncomeExpenseCategory = () => {
    getBrandIncomeExpenseCategory()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.map((item, index) => ({
            name: item.name.replace(/_/g, " "),
            value: item.id,
          }));

          setCategoryItems(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchBrandIncomeExpenseCategory();
  }, []);

  const statusItems = [
    {
      name: "Active",
      value: true,
    },
    {
      name: "DeActive",
      value: false,
    },
  ];

  useEffect(() => {
    if (selectedUserItemValue !== null) {
      setNameValue(selectedUserItemValue?.name || "");
      setDescriptionValue(selectedUserItemValue?.description.toString() || "");
      setCategoryValue(selectedUserItemValue?.incomeExpenseCategory?.id || "");
      setStatusValue(selectedUserItemValue?.status || false);
    }
  }, [selectedUserItemValue]);

  const handleConfirmPickup = () => {
    // Reset all previous errors

    setNameError("");
    setDescriptionError("");
    setCategoryError("");
    setStatusError("");

    let isValid = true;

    if (!nameValue) {
      setNameError("Name is required");
      isValid = false;
    }
    if (!descriptionValue) {
      setDescriptionError("Description is required");
      isValid = false;
    }

    if (selectedUserItemValue === null && categoryValue === "") {
      setCategoryError("Category is required");
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedUserItemValue === null) {
          // Logic for creating a new pickup request
          const data = {
            brandId: brandId,
            incomeExpenseCategory: {
              id: categoryValue,
            },
            name: nameValue,
            description: descriptionValue,
            status: true,
          };

          // Call the service function for creating pickup request

          addBrandIncomeExpense(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setNameValue("");
                  setDescriptionValue("");
                  setCategoryValue("");
                  setStatusValue("");

                  setNameError("");
                  setDescriptionError("");
                  setCategoryError("");

                  setIsSubmitButtonPressed(false);
                  sendDataToUserList({
                    success: true,
                  });
                  setIncomeExpenseCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const data = {
            ...selectedUserItemValue,
            brandId: brandId,
            incomeExpenseCategory: {
              id: categoryValue,
            },
            name: nameValue,
            description: descriptionValue,
            status: statusValue,
          };
          // Call the service function for creating pickup request

          updateBrandIncomeExpense(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  if (status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(message);
                  }

                  setNameValue("");
                  setDescriptionValue("");
                  setCategoryValue("");
                  setStatusValue("");

                  setNameError("");
                  setDescriptionError("");
                  setCategoryError("");
                  setIsSubmitButtonPressed(false);
                  sendDataToUserList({
                    success: true,
                  });
                  setIncomeExpenseCreateModalVisible(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  const handleModalClose = () => {
    setNameValue("");
    setDescriptionValue("");
    setCategoryValue("");
    setStatusValue("");

    setNameError("");
    setDescriptionError("");
    setCategoryError("");
    setStatusError("");
    setIsSubmitButtonPressed(false);
    sendDataToUserList({
      success: true,
    });
    setIncomeExpenseCreateModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        visible={incomeExpenseCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!incomeExpenseCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                {selectedUserItemValue ? (
                  <i
                    className="pi pi-pencil"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  ></i>
                ) : (
                  <img src={"images/plus.png"} style={{ width: 30 }} />
                )}
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                {selectedUserItemValue ? "Edit" : "ADD"} INCOME/ EXPENSE
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>

            <div className="mx-4">
              <InputText
                value={nameValue}
                onChange={(e) => {
                  setNameValue(e.target.value);
                  setNameError("");
                }}
                className="w-full text-xl p-2 border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
                placeholder="Name"
              />
              {nameError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {nameError}
                </p>
              )}
            </div>

            <div className="mx-4">
              <InputTextarea
                id="description"
                value={descriptionValue}
                onChange={(e) => {
                  setDescriptionValue(e.target.value);
                  setDescriptionError("");
                }}
                className="w-full text-xl p-2 border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
                placeholder="Description"
              />
              {descriptionError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {descriptionError}
                </p>
              )}
            </div>

            <div className="mx-4">
              <div className="flex flex-1 ">
                <Dropdown
                  value={categoryValue}
                  onChange={(e) => {setCategoryValue(e.value);setCategoryError("")}}
                  options={categoryItems}
                  optionLabel="name"
                  placeholder="Category"
                  className="w-full border-round-xl  text-2xl text-xl shadow-2"
                />
              </div>
              {categoryError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {categoryError}
                </p>
              )}
            </div>
           { selectedUserItemValue !== null && <div className="mx-4 mt-1 ">
              <Dropdown
                id="statusValue"
                value={statusValue}
                onChange={(e) => setStatusValue(e.value)}
                options={statusItems}
                optionLabel="name"
                placeholder="Status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
            </div>}

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl "
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default IncomeExpenseCreateModal;
